import { storage } from '@otto-ec/global-resources/storage';

export function getLocalStorage() {
    return storage(() => window.localStorage);
}
